var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.logged && _vm.path != 'form-quote' && _vm.path != 'form-price')?_c('div',{staticClass:"is-login d-flex"},[_c('div',{staticClass:"app-content-right",class:[
        _vm.showText ? 'app-content-right-full' : '',
        _vm.isPopupChat ? 'pb100' : ''
      ]},[_c('div',{staticClass:"header-top"},[_c('header-top')],1),_c('div',{staticClass:"content-bottom"},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1)],1)])]):_c('div',{staticClass:"not-login"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }